import { useTranslation } from "react-i18next";
import {
  useCategoryPageData,
  useCurrentTest,
} from "../../FuturebilityCockpit/hooks";
import { CalculationType, Category } from "../../FuturebilityCockpit/types";
import { getCurrentFormattedDate } from "../utils";
import { ExtendedCube } from "../ExtendedCube";
import ItemsPage from "./ItemsPage";
import { ModuleProps } from "./../types";
import { BottomBar } from "../../ParticipationFlow/components/bottom-bar";

function AnalyticsModule({ rawData }: ModuleProps) {
  const { t } = useTranslation();
  const currentTest = useCurrentTest(undefined, rawData);
  const logoUrl = rawData?.client.logoUrl?.trim() || "/logo.png";

  const organizationCategoryData = useCategoryPageData({
    currentCategory: Category.Organization,
    rawData,
    currentTestId: currentTest?._id ?? "",
    selectedFilters: undefined,
  });

  const teamCategoryData = useCategoryPageData({
    currentCategory: Category.Team,
    rawData,
    currentTestId: currentTest?._id ?? "",
    selectedFilters: undefined,
  });

  const leadershipCategoryData = useCategoryPageData({
    currentCategory: Category.Leadership,
    rawData,
    currentTestId: currentTest?._id ?? "",
    selectedFilters: undefined,
  });

  return (
    <>
      <div className="page start-html-page">
        <div className="header">
          <div
            className="customer-logo"
            style={{
              backgroundImage: `url(${logoUrl})`,
            }}
          />
          <div className="date">{getCurrentFormattedDate()}</div>
        </div>
        <div className="content">
          {currentTest?.startReportHtml && (
            <div
              className="start-html-text"
              dangerouslySetInnerHTML={{
                __html: currentTest.startReportHtml,
              }}
            />
          )}
        </div>

        <div className="footer">
          <BottomBar />
        </div>
      </div>

      <div className="page page-cube">
        <div className="header">
          <div
            className="customer-logo"
            style={{
              backgroundImage: `url(${logoUrl})`,
            }}
          />
        </div>
        <div className="content">
          <div className="content-header">
            {t(
              "frontend.futurebilityCockpit.categories.organization.title",
              "Organization"
            )}
          </div>
          <div className="cube">
            <ExtendedCube
              scaleFactor={1}
              cubeSidesData={organizationCategoryData.cubeSidesData}
              scoreCalculationType={CalculationType.AverageScore}
              showBenchmark={true}
            />
          </div>
        </div>

        <div className="footer">
          <BottomBar />
        </div>
      </div>

      <ItemsPage cubeSides={organizationCategoryData.cubeSidesData} />

      <div className="page page-cube">
        <div className="header">
          <div
            className="customer-logo"
            style={{
              backgroundImage: `url(${logoUrl})`,
            }}
          />
        </div>
        <div className="content">
          <div className="content-header">
            {t("frontend.futurebilityCockpit.categories.team.title", "Team")}
          </div>
          <div className="cube">
            <ExtendedCube
              scaleFactor={1}
              cubeSidesData={teamCategoryData.cubeSidesData}
              scoreCalculationType={CalculationType.AverageScore}
              showBenchmark={true}
            />
          </div>
        </div>

        <div className="footer">
          <BottomBar />
        </div>
      </div>

      <ItemsPage cubeSides={teamCategoryData.cubeSidesData} />

      <div className="page page-cube">
        <div className="header">
          <div
            className="customer-logo"
            style={{
              backgroundImage: `url(${logoUrl})`,
            }}
          />
        </div>
        <div className="content">
          <div className="content-header">
            {t(
              "frontend.futurebilityCockpit.categories.leadership.title",
              "Leadership"
            )}
          </div>
          <div className="cube">
            <ExtendedCube
              scaleFactor={1}
              cubeSidesData={leadershipCategoryData.cubeSidesData}
              scoreCalculationType={CalculationType.AverageScore}
              showBenchmark={true}
            />
          </div>
        </div>

        <div className="footer">
          <BottomBar />
        </div>
      </div>

      <ItemsPage cubeSides={leadershipCategoryData.cubeSidesData} />
    </>
  );
}

export default AnalyticsModule;
